module.exports = __webpack_public_path__ + "static/media/stephanie-farr.ffc7c64d.png";